import React, { useState } from 'react';
import Modal from './Modal';

const NoCostReasonModal = ({ isOpen, onClose, onConfirm, description }) => {
  const [reason, setReason] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!reason.trim()) {
      setError('El motivo es obligatorio');
      return;
    }

    onConfirm(reason.trim());
    setReason('');
    setError('');
  };

  const handleClose = () => {
    setReason('');
    setError('');
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} title="Marcar Entrada Sin Costo">
      <div className="space-y-4">
        {description && (
          <p className="text-sm text-gray-600">{description}</p>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="noCostReason" className="block text-sm font-medium text-gray-700 mb-2">
              Motivo *
            </label>
            <textarea
              id="noCostReason"
              value={reason}
              onChange={(e) => {
                setReason(e.target.value);
                if (error) setError('');
              }}
              rows={4}
              className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500 ${
                error ? 'border-red-500' : 'border-gray-300'
              }`}
              placeholder="Ingrese el motivo por el cual la entrada no tiene costo..."
              required
            />
            {error && (
              <p className="text-red-600 text-sm mt-1">{error}</p>
            )}
          </div>

          <div className="flex justify-end space-x-3">
            <button
              type="button"
              onClick={handleClose}
              className="px-4 py-2 text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-500"
            >
              Cancelar
            </button>
            <button
              type="submit"
              disabled={!reason.trim()}
              className={`px-4 py-2 rounded-md focus:outline-none focus:ring-2 ${
                !reason.trim()
                  ? 'bg-gray-400 text-gray-600 cursor-not-allowed'
                  : 'bg-teal-600 text-white hover:bg-teal-700 focus:ring-teal-500'
              }`}
            >
              Confirmar
            </button>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default NoCostReasonModal;
